'use es6';

import { fromJS } from 'immutable';
import { getAccounts } from '../features/accounts';
import { makeDebouncedAction } from '../utils/ActionUtils';
import { serializableError } from '../utils/utils';
import ActionTypes from './ActionTypes';
export const fetchAccounts = makeDebouncedAction(dispatch => {
  dispatch({
    type: ActionTypes.ACCOUNTS_REQUESTING
  });
  const promise = getAccounts().then(res => dispatch({
    type: ActionTypes.ACCOUNTS_RECEIVED,
    payload: fromJS(res)
  }), err => dispatch({
    type: ActionTypes.ACCOUNTS_ERROR,
    payload: serializableError(err)
  }));
  promise.catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return promise;
}, 3000, {
  leading: true,
  trailing: false
});